import React from 'react';
import { ResponsiveRadar } from '@nivo/radar';

export default function RadarChart({ data }) {
    // install (please make sure versions match peerDependencies)
    // yarn add @nivo/core @nivo/radar

    // make sure parent container have a defined height when using
    // responsive component, otherwise height will be 0 and
    // no chart will be rendered.
    // website examples showcase many properties,
    // you'll often use just a few of them.

    return <div style={{ height: 300 }}>
        <ResponsiveRadar
            data={data}
            keys={['params importance']}
            indexBy="param"
            //valueFormat=">-.2f"
            margin={{ top: 70, right: 80, bottom: 50, left: 80 }}
            borderColor={{ from: 'color' }}
            gridLabelOffset={36}
            dotSize={10}
            dotColor={{ theme: 'background' }}
            dotBorderWidth={2}
            gridShape="linear"
            colors={{ scheme: 'red_yellow_blue' }}
            blendMode="multiply"
            motionConfig="wobbly"
        // legends={[
        //     {
        //         anchor: 'top-left',
        //         direction: 'column',
        //         translateX: -50,
        //         translateY: -40,
        //         itemWidth: 80,
        //         itemHeight: 20,
        //         itemTextColor: '#999',
        //         symbolSize: 12,
        //         symbolShape: 'circle',
        //         effects: [
        //             {
        //                 on: 'hover',
        //                 style: {
        //                     itemTextColor: '#000'
        //                 }
        //             }
        //         ]
        //     }
        // ]}
        /></div>;


}
